import React from "react"
import { ButtonProps } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import CopyToClipboard from "components/elements/CopyToClipboard"

type Props = { text: string } & Omit<ButtonProps, "children">

const CopyIconButton = ({ text, ...props }: Props) => (
  <CopyToClipboard
    text={text}
    size="xs"
    variant="ghost"
    color="gray.600"
    _hover={{ color: "gray.900", bg: "gray.100" }}
    aria-label="Copy"
    title="Copy"
    copiedContent={<Icon icon="checkmark" size={4} color="green.500" />}
    {...props}
  >
    <Icon icon="copy" size={4} />
  </CopyToClipboard>
)

export default CopyIconButton
